import { ReactNode } from 'react';
import { Root } from './composite.styles';
export interface CompositeProps {
    align?: string;
    childMargin?: number;
    children?: ReactNode;
    divider?: boolean;
    fillParent?: boolean;
    gap?: number;
    justify?: string;
    noWrap?: boolean;
    overflow?: string;
    reverse?: boolean;
    paddingVertical?: number;
    paddingHorizontal?: number;
}
export function Composite({
    align = 'center',
    childMargin,
    children,
    divider = false,
    fillParent = false,
    gap,
    justify = 'space-between',
    noWrap = false,
    overflow,
    reverse = false,
    paddingVertical = 0,
    paddingHorizontal = 0,
}: CompositeProps) {
    return (
        <Root
            $align={align}
            $childMargin={childMargin}
            $divider={divider}
            $fillParent={fillParent}
            $gap={gap}
            $justify={justify}
            $noWrap={noWrap}
            $overflow={overflow}
            $reverse={reverse}
            $paddingVertical={paddingVertical}
            $paddingHorizontal={paddingHorizontal}
        >
            {children}
        </Root>
    );
}
